import script from "./process-list.vue?vue&type=script&setup=true&lang=js"
export * from "./process-list.vue?vue&type=script&setup=true&lang=js"

import "./process-list.vue?vue&type=style&index=0&id=33e0176a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e0176a"]])

export default __exports__